import Lottie from 'lottie-react'
import Loader from '@/assets/Lottie/wiggot_loader.json'

interface IProps {
  text: string
}
const GridLoader = ({ text }: IProps) => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="w-max h-max">
        <div className="mt-3 -mb-20 flex justify-center">
          <p className="text-base font-bold max-w-[200px] text-center">
            {text}
          </p>
        </div>
        <div className="flex justify-center max-h-[500px]">
          <Lottie id="lottie-loader" animationData={Loader} loop={true} />
        </div>
      </div>
    </div>
  )
}

export default GridLoader
